// This file contains the main URL and image URL for the API.

// export const mainurl = "https://api2.boxfarming.in/wsapi/v2/index.php/"; 
// export const imgurl = "https://api2.boxfarming.in/wsapi/v2/assets/gf566s7hbff/"; 

export const mainurl = "https://vbox.cwsorg.in/api/index.php/"; 
export const imgurl = "https://vbox.cwsorg.in/api/assets/gf566s7hbff/"; 